import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AlertSnackbar({ message, setSnackContent, severity="success", ...otherProps }) {
  const [content, setContent] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [pack, setPack] = useState([]);

  const handleClose = () => {
    setOpen(false);
    setContent(undefined);
    setSnackContent("");
  };

  useEffect(() => {
    message && setPack(prev => [...prev, { message, key: new Date().getTime() }]);
  }, [message]);

  useEffect(() => {
    if (pack.length && !content) {
      setContent({ ...pack[0] });
      setPack(prev => prev.slice(1));
      setOpen(true);
    } else if (pack.length && content && open && pack[0].key !== content.key) {
      setOpen(false);
    }
  }, [pack, content, open]);

  const handleExited = () => {
    setContent(undefined);
  };

  return (//severity = success, info, warning, error
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      {...otherProps}
      TransitionProps={{ onExited: handleExited }}
      key={content?.key}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        <div>{content?.message}</div>
      </Alert>
    </Snackbar>
  );
}